import * as HLF from "html-living-framework";

export class Match2Model<CardType extends { distractor?: boolean }> {

    public readonly length: number;
    private readonly _cards: CardType[];
    private _index1: number = -1;
    private _index2: number = -1;
    private _matches: number = 0;
    private readonly _distractors: number = 0;

    constructor(length: number, uniqueCards: CardType[]) {
        this.length = length;
        this._cards = new Array(length);
        const distractors = uniqueCards.filter((it) => it.distractor);
        const paired = uniqueCards.filter((it) => !it.distractor);
        this._distractors = distractors.length;

        if ((length - this._distractors) % 2 !== 0) {
            throw new Error(`Invalid match 2 model: length=${length}, distractors=${this._distractors}`);
        }

        this._cards = [...distractors];
        for (let i = this._cards.length, j = 0; i < length; i += 2) {
            if (j >= paired.length) {
                j = 0;
            }
            const card = paired[j];
            this._cards[i] = this._cards[i + 1] = card;
            j++;
        }
        HLF.ArrayUtils.shuffle(this._cards);

        // Make sure there are no pairs beside each other
        for (let i = 1; i < this._cards.length - 1; i++) {
            if (this._cards[i - 1] === this._cards[i]) {
                const t = this._cards[i];
                this._cards[i] = this._cards[i + 1];
                this._cards[i + 1] = t;
            }
        }
        if (this._cards[this._cards.length - 2] === this._cards[this._cards.length - 1]) {
            const t = this._cards[0];
            this._cards[0] = this._cards[this._cards.length - 1];
            this._cards[this._cards.length - 1] = t;
        }
    }

    public getCardAt(index: number): CardType {
        return this._cards[index];
    }

    public getOpenCards(): Array<{ card: CardType, index: number }> {
        const indices = this._index1 > -1 && this._index2 > -1 ? [this._index1, this._index2] :
            this._index1 > -1 ? [this._index1] : [];
        return indices.map((it) => ({
            card: this._cards[it],
            index: it,
        }));
    }

    public pickCard(index: number): PickResult {
        if (this._index1 > -1 && this._index2 > -1) {
            this._index1 = -1;
            this._index2 = -1;
        }
        if (this._index1 === index) {
            this._index1 = -1;
            return PickResult.NoCard;
        } else if (this._index1 > -1) {
            this._index2 = index;
            if (this._cards[this._index1] === this._cards[this._index2]) {
                this._matches++;
                return PickResult.Match;
            }
            return PickResult.NoMatch;
        } else {
            this._index1 = index;
            return PickResult.OneCard;
        }
    }

    get isComplete() {
        return this._matches >= (this.length - this._distractors) / 2;
    }

    get unmatched() {
        return Math.round((this.length - this._distractors) / 2 - this._matches);
    }
}

export enum PickResult {
    Match = "Match",
    NoMatch = "NoMatch",
    OneCard = "OneCard",
    NoCard = "NoCard",
}
